module.exports = __webpack_public_path__ + "img/cb.4475de14.png";